module.exports = __webpack_public_path__ + "static/media/assign-credits.72953fac.png";